import { authenticatedFetch } from './client';

/**
 * Start a new analysis.
 *
 * @param reportId - Unique report ID
 */
export async function startAnalysis(reportId: string): Promise<void> {
  const response = await authenticatedFetch(
    `/api/analysis/start/${encodeURIComponent(reportId)}`,
    {
      method: 'POST',
    }
  );

  if (!response.ok) {
    const text = await response.text();
    let errorMessage = 'Failed to start analysis';
    try {
      const err = JSON.parse(text);
      errorMessage = err.detail || errorMessage;
    } catch {
      errorMessage = response.statusText || errorMessage;
    }
    const error = new Error(errorMessage) as Error & { status?: number };
    error.status = response.status;
    throw error;
  }

  // Response not consumed - callers poll /api/analysis/{analysis_id}/status instead
}

/**
 * Register a campaign package from an arbitrary Frame.io folder URL.
 * Parses the folder ID on the backend, fetches folder metadata, and
 * creates a Report in the database so the campaign can be analysed.
 */
export async function registerCampaignFromUrl(url: string): Promise<{
  campaign_name: string;
  folder_id: string;
  status: string;
  report_id: string;
}> {
  const response = await authenticatedFetch('/api/reports/register-from-url', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ url }),
  });

  if (!response.ok) {
    const text = await response.text();
    let errorMessage = 'Failed to register campaign';
    try {
      const err = JSON.parse(text);
      errorMessage = err.detail || errorMessage;
    } catch {
      errorMessage = response.statusText || errorMessage;
    }
    const error = new Error(errorMessage) as Error & { status?: number };
    error.status = response.status;
    throw error;
  }

  return response.json();
}
